<script>
    import { get_attribute_name, get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724765';
    import { url_join } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url.js?1733898724765';
    import { load_product } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/api-client/product/load_product.js?1733898724765';
    import { load_products } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/api-client/product/load_products.js?1733898724765';
    import { process_ga4_item } from '/srv/web/wyvr/html/releases/58819/gen/client/vendor/googletagmanager/ga4.js?1733898724765';
    import { strip_tags } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/sanitize.js?1733898724765';
    import { to_currency } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/currency.js?1733898724765';
    import { get_src } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_src.js?1733898724765';
    import { get_stock } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/product/get_stock.js?1733898724765';
    import Price from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Price.svelte?1733898724765';
    import Badges from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Badges.svelte?1733898724765';
    import Wishlist from '/srv/web/wyvr/html/releases/58819/gen/client/shop/wishlist/ToggleButton.svelte?1733898724765';
    import Compare from '/srv/web/wyvr/html/releases/58819/gen/client/shop/compare/ToggleButton.svelte?1733898724765';
    import Image from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Image.svelte?1733898724765';
    import Swatch from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Swatch.svelte?1733898724765';

    export let product;
    export let store;
    export let locale = 'en';
    export let currency = 'EUR';
    export let position = undefined;
    let lowest_configurable_price;
    let swatches = [];
    const amount_of_swatches = 5;
    let previous_sku;

    const slug = "p";

    $: link = url_join(store, slug, get_attribute_value(product, 'url_key'));
    $: sku = get_attribute_value(product, 'sku');
    $: name = get_attribute_value(product, 'name');
    $: brand = get_attribute_name(product, 'pim_brand');
    $: src = get_src(product);

    $: update_sku(sku);

    function update_sku(sku) {
        if (true && previous_sku !== sku) {
            previous_sku = sku;
            lowest_configurable_price = undefined;
            swatches = [];
            if (product.type_id === 'configurable') {
                // product.osc identifies a odoscope product
                if (product.osc) {
                    odoscopeConfigurableProduct(product);
                } else {
                    // loads the configurable product and its simples
                    loadConfigurableProduct(sku);
                }
            }
        }
    }

    async function loadConfigurableProduct(sku) {
        const [error, loadedProduct] = await load_product(sku);
        if (error) {
            console.error('Could not load product', sku, error);
            return;
        }

        const skus = extractSkusFromProductOptions(loadedProduct);
        if (skus.length === 0) {
            console.warn('the following configurable has no simples', skus);
            return;
        }
        const [error_simples, simples] = await load_products(skus);
        if (error_simples || !simples) {
            return;
        }

        const prices = [];
        // get all prices from the loaded simples
        for (const simple of simples) {
            const price = get_attribute_value(simple, 'final_price') || get_attribute_value(simple, 'price');
            prices.push(price);
        }

        const swatch_products = [];
        // build the swatches from the color attribute
        if (loadedProduct?.configurable_options) {
            //const color_skus = kw_main_color;
            const color_index = {};
            const product_index = {};
            for (const simple of simples) {
                if (!get_stock(simple)?.is_in_stock || get_attribute_value(simple, 'status') !== '1') {
                    continue;
                }
                product_index[get_attribute_value(simple, 'sku')] = simple;
            }

            // get only color skus for the swatches
            for (const options of Object.values(loadedProduct.configurable_options)) {
                if (!options || options.length === 0 || ['color', 'kw_main_color', 'kw_color_configurable_product'].indexOf(options[0].attribute_code) === -1) {
                    continue;
                }

                for (const option of options) {
                    if (color_index[option.value_index]) {
                        continue;
                    }
                    if (product_index[option.sku]) {
                        color_index[option.value_index] = true;
                        swatch_products.push(product_index[option.sku]);
                    }
                }
            }
        }
        // limit the amount of swatch entries
        updateSwatches(swatch_products);

        // set lowest price
        updateLowestPrice(prices);
    }

    function odoscopeConfigurableProduct(product) {
        if (!Array.isArray(product?.variants)) {
            return;
        }
        const prices = [];

        const swatch_products = [];
        let previous_color;
        let color_changed = false;
        for (const variant of product.variants) {
            prices.push(get_attribute_value(variant, 'final_price'));
            const color = get_attribute_value(variant, 'kw_main_color');
            if (previous_color && previous_color !== color) {
                color_changed = true;
            }
            previous_color = color;
            swatch_products.push(variant);
        }
        // if all colors of all variants are equal, do not update the swatches
        if (color_changed) {
            // limit the amount of swatch entries
            updateSwatches(swatch_products);
        }
        // set lowest price
        updateLowestPrice(prices.filter(Boolean));
    }

    function updateSwatches(products) {
        if (!Array.isArray(products) || products.length === 0) {
            return;
        }
        swatches = products.slice(0, amount_of_swatches);
    }

    function updateLowestPrice(prices) {
        // ignore lowest price when there are no prices
        if (Array.isArray(prices) && prices.length > 0) {
            lowest_configurable_price = to_currency(Math.min(...prices), locale, currency);
        }
    }

    function extractSkusFromProductOptions(product) {
        return Object.values(product?.configurable_options ?? {})
            .flat()
            .map((option) => option.sku);
    }

    async function click_tracking(e) {
        const href = e.target.closest('a')?.getAttribute('href');
        if (!href) {
            return;
        }
        e.preventDefault();
        const item = await process_ga4_item(product, 1);
        if (!item) {
            navigate(href);
            return;
        }
        // set the posiiton in the list
        if (position) {
            item.index = position;
        }
        // load list name
        const list_name_element = e.target.closest('[data-list-name]');
        let item_list_name = document.title;
        if (list_name_element) {
            item_list_name = list_name_element.getAttribute('data-list-name') ?? item_list_name;
        }
        gtag('event', 'select_item', {
            ecommerce: {
                item_list_name,
                items: [item]
            }
        });
        // go to the product
        if (href) {
            navigate(href);
        }
    }

    function navigate(href) {
        if (href) {
            setTimeout(() => {
                document.location = href;
            }, 50);
        }
    }

    function get_breaking_name(name) {
        const sane_name = strip_tags(name);
        return sane_name.replace(/([/-])/g, '$1&ZeroWidthSpace;');
    }
</script>

{#if product}
    <div class="product" data-sku={sku} data-type={product.type_id}>
        <div class="product-actions">
            <Wishlist {sku} />
            <Compare {sku} />
        </div>
        <a class="product-item-link" href={link} on:click={click_tracking}>
            <slot name="top" />
            <div class="image">
                <Badges {product} />
                {#if src}
                    <Image {src} alt={strip_tags(name)} width={340} height={340} mode={'contain'} />
                {/if}
            </div>
            <div class="content">
                <div class="name">
                    {#if brand}
                        <div class="h2 m-product-list__brand-name">{brand}</div>
                    {/if}
                    <div class="m-product-list__name">
                        {@html get_breaking_name(name)}
                    </div>
                </div>
                <div class="price-box">
                    {#if lowest_configurable_price}
                        <div class="price-from">
                            <span class="from">{window.__('product.price_starting_at')}</span>
                            <span class="price">{lowest_configurable_price}</span>
                        </div>
                    {:else}
                        <Price {product} {locale} {currency}>
                            <span class="price-request" slot="price_request">
                                {window.__('price_request.state')}
                            </span>
                        </Price>
                    {/if}
                </div>
                {#if swatches.length > 1}
                    <Swatch products={swatches} {store} />
                {/if}
            </div>

            <slot name="bottom" />
        </a>
        <slot name="actions" />
    </div>
{/if}


<style>a {
    text-decoration: none;
    color: var(--color-text);
}
.product {
    display: flex;
    flex-direction: column;
    width: 100%;
    -webkit-transition: 1s ease-in-out;
    transition: 1s ease-in-out;
}
.product-item-link {
    display: flex;
    flex-direction: column;
    height: 100%;
}
.product:hover {
    -webkit-box-shadow: 0 0 10px 2px rgba(119, 119, 119, 0.15);
    box-shadow: 0 0 10px 2px rgba(119, 119, 119, 0.15);
}
.image :global(img) {
    width: 100% !important;
    height: auto !important;
    display: block;
    object-fit: contain;
}
.name {
    padding-bottom: 20px;

    text-align: center;
}

.name:before {
    margin-bottom: 12px !important;
    position: relative;
    display: block;
    content: '';
    width: 100%;
    height: 2px;
    background: var(--darkgray);
    margin: 0 auto;
}

.product .content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
    -webkit-transition: 1s ease-in-out;
    transition: 1s ease-in-out;
}

.product:hover .content {
    background: #fef8e9;
}


    .product .price-from {
        line-height: 1.2;
        gap: 0.5rem;
    }

    .price-from .from {
        margin-right: 0.125rem;
    }

    .product .price-box {
        display: flex;
        justify-content: center;
        text-align: center;
        padding-top: 10px !important;
    }

    .product :global(.price--percentage) {
        display: none;
        visibility: hidden;
        opacity: 0;
    }

    .product :global(.price) {
        font-weight: 400 !important;
        line-height: 1.2;
        text-transform: uppercase;
        font-size: var(--h3__font-size);
        margin: 0;

        @media (min-width: 992px) {
            font-size: var(--h3__font-size-desktop);
        }
    }

    .product .name {
        padding-bottom: 0;
    }

    .product :global(.price--uvp) {
        display: inline-block;
    }

    .product :global(.price--old) {
        display: inline-block;
        font-size: 1rem !important;
    }

    .product :global(.price--new) {
        width: 100%;
    }

    .product {
        display: flex;
        flex-direction: column;
        position: relative;
    }

    .content {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 10px;
    }

    .product-item-link :global(.m-product-price__price-box) {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
    }

    .product-item-link .image {
        padding: 1rem;
    }

    .product:hover .product-actions {
        opacity: 1;
    }

    .product-actions {
        position: absolute;
        right: 0;
        top: 0;
        text-align: right;
    }

    .product-actions :global(button .text) {
        display: none;
        margin-right: none;
    }

    .product-actions {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        opacity: 0;
        -webkit-transition: 1s ease-in-out;
        transition: 1s ease-in-out;
    }

    .price-request {
        text-transform: uppercase;
    }

</style>